/**
 * @generated SignedSource<<dcd829685fa7f307f0f13331c5274a33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NotionSendNotesModalAsyncTaskQuery$variables = {
  taskId: any;
};
export type NotionSendNotesModalAsyncTaskQuery$data = {
  readonly viewer: {
    readonly asyncTask: {
      readonly info: any;
      readonly state: string;
      readonly taskId: any;
    } | null;
  };
};
export type NotionSendNotesModalAsyncTaskQuery = {
  response: NotionSendNotesModalAsyncTaskQuery$data;
  variables: NotionSendNotesModalAsyncTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "taskId",
      "variableName": "taskId"
    }
  ],
  "concreteType": "AsyncTask",
  "kind": "LinkedField",
  "name": "asyncTask",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "info",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotionSendNotesModalAsyncTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotionSendNotesModalAsyncTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc71dd2c9e06eaa09ee00d87985f817f",
    "id": null,
    "metadata": {},
    "name": "NotionSendNotesModalAsyncTaskQuery",
    "operationKind": "query",
    "text": "query NotionSendNotesModalAsyncTaskQuery(\n  $taskId: JSON!\n) {\n  viewer {\n    asyncTask(taskId: $taskId) {\n      taskId\n      state\n      info\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec83f8f22d12634a833c7a9b2b1951e8";

export default node;
